<wlm-configurable-form
  *ngIf="settings && fields"
  [initialModel]="initialModel"
  [fieldConfig]="fields"
  [formOptions]="formOptions"
  [formDisabled]="isDisabled$ | async"
  (modelChange)="onModelChange($event)"
  (isValid)="onIsValid($event)"
  (hasChanges)="onHasChanges($event)"
></wlm-configurable-form>
